import { render } from "./TheBaoCaoKTXH.vue?vue&type=template&id=7c892e93"
import script from "./TheBaoCaoKTXH.vue?vue&type=script&lang=js"
export * from "./TheBaoCaoKTXH.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__